import { ThemeTokens } from '../tokens';

export const lightTheme: ThemeTokens = {
  canvas: {
    gradient: 'linear-gradient(135deg, #f5f5f5 0%, #e0e0e0 50%, #f5f5f5 100%)',
    panel: '#ffffff',
    menu: '#f5f5f5',
  },
  card: {
    background: '#ffffff',
    backgroundGradient: 'linear-gradient(135deg, rgba(0,0,0,0.02) 0%, rgba(0,0,0,0.01) 100%)',
    border: '0.5px solid rgba(0, 0, 0, 0.12)',
    hoverBorder: '1px solid rgba(0, 0, 0, 0.3)',
    hoverShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
  },
  border: {
    light: '1px solid rgba(0, 0, 0, 0.12)',
  },
  text: {
    primary: '#000000',
    secondary: 'rgba(0, 0, 0, 0.6)',
    disabled: 'rgba(0, 0, 0, 0.38)',
  },
  interactive: {
    hover: 'rgba(0, 0, 0, 0.04)',
    active: '#e0e0e0',
    toggleBg: 'rgba(0, 0, 0, 0.08)',
    toggleBorder: 'rgba(0, 0, 0, 0.12)',
    toggleInactive: 'rgba(0, 0, 0, 0.4)',
    toggleActive: 'rgba(0, 0, 0, 0.12)',
    toggleActiveText: 'rgba(0, 0, 0, 0.87)',
  },
  accent: {
    avatar: {
      gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    },
    success: {
      bg: 'rgba(76, 175, 80, 0.15)',
      bgHover: '#4CAF50',
    },
    icon: '#00A0A0',
  },
  dropdown: {
    background: '#ffffff',
    sectionText: 'rgba(0, 0, 0, 0.6)',
    optionText: 'rgba(0, 0, 0, 0.87)',
    optionHoverBg: 'rgba(0, 0, 0, 0.04)',
    divider: 'rgba(0, 0, 0, 0.12)',
    checkboxUnchecked: 'rgba(0, 0, 0, 0.54)',
  },
};
